import React, { useState, useEffect } from 'react'
import { Box, Flex, Heading, Text, Button, Spinner } from '@chakra-ui/react'
import { useAuth } from '../contexts/AuthContext'
import LoginModal from './LoginModal'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { currentUser, loading } = useAuth()
  const [showLoginModal, setShowLoginModal] = useState(false)

  useEffect(() => {
    if (!currentUser && !loading) {
      setShowLoginModal(true)
    }
  }, [currentUser, loading])

  const handleCloseModal = () => {
    setShowLoginModal(false)
  }

  if (loading) {
    return (
      <Box
        minH="100vh"
        bg="gray.50"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Flex flexDirection="column" alignItems="center" gap={4}>
          <Spinner size="xl" color="blue.600" thickness="4px" />
          <Text color="gray.600">로그인 확인 중...</Text>
        </Flex>
      </Box>
    )
  }

  if (!currentUser) {
    return (
      <>
        <Box
          minH="100vh"
          bg="gray.50"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Flex flexDirection="column" alignItems="center" gap={6}>
            <Heading as="h2" size="xl" color="gray.900">
              관리자 페이지
            </Heading>
            <Text color="gray.600">로그인이 필요합니다</Text>
            <Button
              colorScheme="blue"
              size="lg"
              onClick={() => setShowLoginModal(true)}
              _hover={{ bg: 'blue.700' }}
            >
              로그인하기
            </Button>
          </Flex>
        </Box>
        <LoginModal isOpen={showLoginModal} onClose={handleCloseModal} />
      </>
    )
  }

  return <>{children}</>
}

export default ProtectedRoute
